module.exports = __webpack_public_path__ + "static/img/cg.e7618e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cg.png
// module id = ZS3z
// module chunks = 1